module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter7"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block11"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p281"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps-rw",
    staticStyle: {
      "font-size": "82%"
    }
  }, [_vm._v("HE NEXT DAY")]), _vm._v(" was a half-day at Lauren’s school, and Parker waited at the bus stop for her return. He knew she was old enough to make it the two blocks from the stop to the house. But he had been meeting her after school as regularly as he was able since she was very young, and he didn’t feel the urge to stop now. Sometimes she told him not to come, that her friends would make fun of her. He came anyway, because that’s what dads did for their daughters.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p282"
    }
  }, [_vm._v("He saw the yellow bus rise out of the silvery heat coming up from the asphalt, and he put on a smile as the bus came closer. It slowed and stopped, and its shadow fell over him. Parker waved to the bus driver, and the driver gave him a little salute. Parker was aware of the eyes of young teenagers watching him from the windows. Lauren came off, and he saw that she was aware of them, too. She clutched her books to her body and hunched her shoulders without looking at him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_vm._v("“Hey, there,” Parker said to Lauren as the bus left. She was already walking, and he hurried to catch up. “How was school today?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("“Fine,” Lauren said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_vm._v("“Just fine? Learn anything new and exciting?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("Lauren regarded him with a sour eye. “It was the last day of school, Dad. We’re not learning anything on the last day of school.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_vm._v("“Yeah, I guess not. Still…there’s got to be things going on.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("“Nothing, Dad,” Lauren said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p289"
    }
  }, [_vm._v("“Absolutely nothing? You guys sat there and stared at the walls all day?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p290"
    }
  }, [_vm._v("He caught the slightest hint of a smile, but she stanched it. “They gave us busy work. I had to write an essay on what I’m doing this summer. That’s the kind of thing "), _c('i', [_vm._v("kids")]), _vm._v(" do.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p291"
    }
  }, [_vm._v("“That’s tough,” Parker sympathized. “They should have asked you about how we can have world peace.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p292"
    }
  }, [_vm._v("“I’m "), _c('i', [_vm._v("serious,")]), _vm._v(" Dad! It’s stupid. If they don’t have anything for us to do, they could cancel classes and let us all go home a week early.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p293"
    }
  }, [_vm._v("“I don’t know if I’m ready to have you home all day right now,” Parker said. “I could use another week. How about summer school? You ever think about summer school?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p294"
    }
  }, [_vm._v("Now Lauren did smile, and she punched Parker in the arm. “That’s not funny. Only stoners and juvies go to summer school. You want me to lose "), _c('i', [_vm._v("all")]), _vm._v(" my friends?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p295"
    }
  }, [_vm._v("Parker threw his arm around her and squeezed her shoulders. “I want you to be happy. That’s all. Whatever it takes to make you happy.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p296"
    }
  }, [_vm._v("They walked like that part of the way. Lauren put her head against him, and Parker was glad. She was so tall now. In only three years she’d grown like a weed. He remembered holding her hand to balance her as she walked for the first time. “Dad?” she asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p297"
    }
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p298"
    }
  }, [_vm._v("“Did you find a job today?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p299"
    }
  }, [_vm._v("The pleasant feeling fled Parker. He sighed. As if it was a signal, Lauren slipped away from him and put her gaze on him. He felt shrunken in her sight. “No, I didn’t find a job today,” he said. “But I looked. I really did look.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p300"
    }
  }, [_vm._v("“I guess that’s good enough,” Lauren said, but she did not come back to his arm again. They walked apart the rest of the way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p301"
    }
  }, [_vm._v("Parker got the front door unlocked and held it for Lauren before he heard the rumble of the engine. It was as distinctive as a fingerprint. “Hey, go inside and relax a little while,” he told Lauren. “Uncle Matt is coming.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p302"
    }
  }, [_vm._v("“Ugh,” Lauren said. But she did as he said and vanished indoors.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("He waited on the front walk until he saw the familiar yellow-and-black Charger coming down the block. Matt had the windows down and a tanned arm propped in the window as he cruised the old car to a stop at the curb. He cut the engine and climbed out. “"), _c('i', [_vm._v("Hola,")]), _vm._v(" Parker,” he said. “What’s up?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("“Not much.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p305"
    }
  }, [_vm._v("“Catch you at a bad time?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("“No. I was just getting ready to fix Lauren a snack.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("Matt approached him. He was a lean man, so much so that his skin seemed tight over his flesh and bones. His hair was lank and brown and came down floppily over one eye. Matt was always brushing it back, but it fell in the same place every time. Parker did not know why he didn’t cut it. “Lauren, huh? Maybe I should go in and say hello.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("“It’s okay,” Parker said. “She only got off the bus a few minutes ago. She needs some downtime.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("“Sure, whatever,” Matt said, and he brushed his hair from his face. “I came to talk business anyway.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("“What about it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p311"
    }
  }, [_vm._v("“Well, do you have the charter all set up?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("“I’m still working on it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("Matt frowned. The expression pulled taut skin even more tightly. “Parker, we don’t have all the time in the world. Now is this lady going to take our money or not?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("“I don’t know. I’m trying to work my way around to it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("“There’s no more time for that. The Cubans are getting antsy, and they want to get this done soon. They’re waiting on us to give them a window. I can’t stall them forever.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p316"
    }
  }, [_vm._v("“I’ll get on it,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p317"
    }
  }, [_vm._v("“Okay,” Matt said, and the frown vanished. “And there’s one other thing: I wanted to throw the guys a little bit of money to keep them happy. So I need about a thousand right now.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p318"
    }
  }, [_vm._v("Parker stood with his back to the door, aware of the house and Lauren and everything inside. He did not let worry cross his face. “I can’t do that right now. You know how it is.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p319"
    }
  }, [_vm._v("“Hey, come on, Parker, who’s the man in charge of all this?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p320"
    }
  }, [_vm._v("“You are.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p321"
    }
  }, [_vm._v("“Right. So I need some of the money. Like right this minute.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p322"
    }
  }, [_vm._v("“It’s not where I can get at it,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p323"
    }
  }, [_vm._v("Again Matt swept the hair back. Again it fell into place. His eyes had darkened. “Where did you put it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p324"
    }
  }, [_vm._v("“Somewhere safe. Even I can’t get at it right away.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p325"
    }
  }, [_vm._v("“Did you put it in a safe deposit box or something?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p326"
    }
  }, [_vm._v("“You told me not to say,” Parker said. He thought of the loose piece of wainscoting. Even if Matt looked, he would not see it. “You told me to take the case, put it somewhere where only I knew where to find it, and sit on the money until it was time to divide it up. So that’s what I did.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p327"
    }
  }, [_vm._v("“How are you paying the rent on this place?” Matt asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p328"
    }
  }, [_vm._v("“We get assistance. And I had a little money saved up. It’s enough to get us through until this pays off.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p329"
    }
  }, [_vm._v("“Until it pays off,” Matt said. “I guess that’s all up to you now.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p330"
    }
  }, [_vm._v("“I’ll get us the boat.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p331"
    }
  }, [_vm._v("Matt scrutinized him. The darkness had not gone away. “I want to meet the captain. Can I do that much, or are you keeping her all to yourself?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p332"
    }
  }, [_vm._v("“Sure, you can meet her,” Parker said. “Just don’t…don’t push too hard. I get the feeling she’ll say no if you push too hard.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p333"
    }
  }, [_vm._v("Now Matt smiled broadly and spread his hands as if to take Parker up in a hug. His arms were spidery, the muscles long and raw. “Hey, do I look like the kind of guy who’d screw up your thing? I put all my trust in you, man. We’re partners for life.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p334"
    }
  }, [_vm._v("A tension eased in Parker’s chest, and he breathed a little more deeply. “I’ll call her up and see when we can see her. Maybe tonight. I’ll have to check.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p335"
    }
  }, [_vm._v("“You call me with the time and the place, and I’ll swing by to pick you up,” Matt said. “Okay?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p336"
    }
  }, [_vm._v("“Absolutely,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p337"
    }
  }, [_vm._v("“I can’t wait to lay eyes on this chick. Is she hot, or what?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p338"
    }
  }, [_vm._v("“Yeah, she’s good-looking.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p339"
    }
  }, [_vm._v("“Does she have big, giant titties?” Matt asked, and his smile turned wolfish.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p340"
    }
  }, [_vm._v("“They’re okay,” Parker said. He imagined Camaro beneath him and above him. He imagined her beside him in the little bed at the bow of the boat. These were things Matt could not know.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p341"
    }
  }, [_vm._v("“All right, then. See you later, bro.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p342"
    }
  }, [_vm._v("“Bye,” Parker said. He went inside and closed the door, and then he watched Matt through the peephole until the Charger drove away. He relaxed only when he couldn’t hear the engine anymore.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713e6538","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s010-Chapter-007.vue
// module id = 87
// module chunks = 0